export default __webpack_public_path__ + "static/media/forum-svgrepo-com.c8cf1b4a.svg";